export const editMutations = <const>{
	SKLAD_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'SKLAD_NAKLADOVE_STREDISKO_SELECT_MAPPER',
	SKLAD_MISTO_SELECT_MAPPER: 'SKLAD_MISTO_SELECT_MAPPER',
	DEALERKVPS_SELECT_MAPPER: 'DEALERKVPS_SELECT_MAPPER',
};
